import { MDBBtn } from "mdb-react-ui-kit";
import * as React from 'react';
export default {
  MDBBtn,
  React
};